<form [formGroup]="wineForm" (ngSubmit)="onSubmit(wineForm.value)">
    <h2 mat-dialog-title>Update wine</h2>
    <mat-dialog-content>
        <div class="example-container" fxLayout="column">
            <mat-form-field>
                <input matInput id="name" type="text" formControlName="name" placeholder="Name">
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="year" type="number" placeholder="Year">
            </mat-form-field>
            <mat-form-field>
                <input matInput formControlName="amount" type="number" placeholder="Number">
            </mat-form-field>
            <mat-form-field>
                <mat-select formControlName="size" placeholder="Size">
                    <mat-option value="75cl">75cl</mat-option>
                    <mat-option value="50cl">50cl</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <!--<button class="mat-raised-button" mat-dialog-close>Close</button>-->
        <button mat-raised-button type="button" (click)="onDelete()" color="warn">Delete</button>
        <button mat-raised-button type="submit" color="primary">Save</button>
    </mat-dialog-actions>
</form>